import { Outlet, createFileRoute } from "@tanstack/react-router";

import { requirePermission } from "~/lib/functions/admin-access";

export const Route = createFileRoute("/admin/courses")({
  staticData: { title: "Courses" },
  beforeLoad: ({ context }) =>
    requirePermission(context.adminPermissions, "courses:read"),
  component: () => <Outlet />,
});
